<template><div><h1 id="einfuhrung-neues-loginsystem" tabindex="-1"><a class="header-anchor" href="#einfuhrung-neues-loginsystem"><span>Einführung neues Loginsystem</span></a></h1>
<p>Nachdem wir in v10.71 die Grundlagen geschaffen haben, um die verschiedenen bisher genutzten Logins in ein einheitliches Login-System zu integrieren, wird mit es mit v10.72 eingeführt.</p>
<h2 id="warum" tabindex="-1"><a class="header-anchor" href="#warum"><span>Warum:</span></a></h2>
<p>Diese Anpassungen ermöglichen nicht nur, ein zentralisiertes Login anzubieten, sondern auch zukünftig erweiterte Funktionen wie Mehr-Faktor-Authentifizierung (MFA) oder Single-Sign-On (SSO) mit Diensten wie Office 365 oder Google Workspace zu integrieren.</p>
<p>Für dich bedeutet das, dass du zukünftig nur noch einen einzigen Benutzernamen und ein Passwort für alle unsere Dienste benötigst und gleichzeitig von zusätzlichen Sicherheitsfeatures profitierst. In den nächsten Wochen übertragen wir schrittweise unser Ticketsystem, die Dokumentation und zuletzt die einzelnen funtrade Datenbanken auf die neue Plattform. Als Benutzer geniesst du eine vereinfachte Anmeldung, die trotzdem den modernen Sicherheitsstandards entspricht.</p>
<h2 id="ich-bin-benutzer-der-funtrade-webanwendung" tabindex="-1"><a class="header-anchor" href="#ich-bin-benutzer-der-funtrade-webanwendung"><span>Ich bin Benutzer der funtrade Webanwendung</span></a></h2>
<p>Das neue Loginsystem bringt vor allem Vorteile für Benutzer der funtrade Webanwendung.</p>
<h3 id="_11-04-24-funtrade-release-testsystem-v10-72" tabindex="-1"><a class="header-anchor" href="#_11-04-24-funtrade-release-testsystem-v10-72"><span>11.04.24: funtrade Release Testsystem v10.72</span></a></h3>
<ul>
<li>Kopie der Benutzer von funtrade Prod in neues Loginsystem</li>
<li>Login für Ticketsystem und Doku nun mit neuem Loginsystem [Email + Passwort aus funtrade Prod zum Zeitpunkt der Mirgation]</li>
<li>Login in funtrade Test ab nun mit neuem Loginsystem [Email + Passwort aus funtrade Prod zum Zeitpunkt der Mirgation]</li>
</ul>
<div class="hint-container warning">
<p class="hint-container-title">Hinweis</p>
<p>Wichtig: Änderung des Passworts in funtrade Prod und funtrade Test bewirken eine Passwortänderung in allen Systemen. Siehe Punkt &quot;Passwortänderungen&quot;.</p>
</div>
<h3 id="_25-04-24-funtrade-release-produktiv-v10-72" tabindex="-1"><a class="header-anchor" href="#_25-04-24-funtrade-release-produktiv-v10-72"><span>25.04.24: funtrade Release Produktiv v10.72</span></a></h3>
<p>Login in funtrade Prod ab nun mit neuem Login</p>
<div class="hint-container warning">
<p class="hint-container-title">Hinweis</p>
<p>Ab nun sind alle Systeme mit nur einem Login erreichbar.</p>
</div>
<h2 id="ich-bin-benutzer-der-funtrade-desktopanwendung" tabindex="-1"><a class="header-anchor" href="#ich-bin-benutzer-der-funtrade-desktopanwendung"><span>Ich bin Benutzer der funtrade Desktopanwendung</span></a></h2>
<h3 id="_11-04-24-funtrade-release-testsystem-v10-72-1" tabindex="-1"><a class="header-anchor" href="#_11-04-24-funtrade-release-testsystem-v10-72-1"><span>11.04.24: funtrade Release Testsystem v10.72</span></a></h3>
<ul>
<li>Kopie der Benutzer von funtrade Prod in neues Loginsystem</li>
<li>Login für Ticketsystem und Doku nun mit neuem Loginsystem [Kürzel + Passwort in funtrade Prod]</li>
<li>Login in funtrade Test nach wie vor über altes Login [Kürzel + Passwort in funtrade Test]</li>
</ul>
<div class="hint-container warning">
<p class="hint-container-title">Hinweis</p>
<p>Wichtig: Änderung des Passworts in funtrade Prod und funtrade Test bewirken keine Passwortänderung in den anderen Systemen.</p>
</div>
<h3 id="_25-04-24-funtrade-release-produktiv-v10-72-1" tabindex="-1"><a class="header-anchor" href="#_25-04-24-funtrade-release-produktiv-v10-72-1"><span>25.04.24: funtrade Release Produktiv v10.72</span></a></h3>
<p>Login in funtrade Prod nach wie vor mit alten Login [Kürzel+Passwort in funtrade Prod]</p>
<div class="hint-container warning">
<p class="hint-container-title">Hinweis</p>
<p>Ticketsystem und Dokumentation verwenden [Email + Passwort von funtrade Prod zum Zeitpunkt der Migration am 11.04.2024].</p>
</div>
<h1 id="passwortanderungen" tabindex="-1"><a class="header-anchor" href="#passwortanderungen"><span>Passwortänderungen</span></a></h1>
<p>Passwortänderungen wirken sich gleich aus, sofern sie auf der Prod Version ausgeführt werden.</p>
<h2 id="passwortanderungen-in-der-funtrade-webversion" tabindex="-1"><a class="header-anchor" href="#passwortanderungen-in-der-funtrade-webversion"><span>Passwortänderungen in der funtrade Webversion</span></a></h2>
<p>Sollten in <strong>funtrade Web Prod</strong> durchgeführt werden und wirken sich auf die Anwendung aus:</p>
<ul>
<li>funtrade Desktop Prod</li>
<li>funtrade Web Prod</li>
<li>funtrade Web Test</li>
<li>Ticketsystem</li>
<li>Dokumentation</li>
</ul>
<p>nicht aber auf:</p>
<ul>
<li>funtrade Desktop Test</li>
</ul>
<h2 id="passwortanderungen-in-der-funtrade-desktopversion" tabindex="-1"><a class="header-anchor" href="#passwortanderungen-in-der-funtrade-desktopversion"><span>Passwortänderungen in der funtrade Desktopversion</span></a></h2>
<p>Sollten in <strong>funtrade Desktop Prod</strong> durchgeführt werden und wirken sich auf die Anwendung aus:</p>
<ul>
<li>funtrade Desktop Prod</li>
<li>funtrade Web Prod</li>
<li>funtrade Web Test</li>
<li>Ticketsystem</li>
<li>Dokumentation</li>
</ul>
<p>nicht aber auf:</p>
<ul>
<li>funtrade Desktop Test</li>
</ul>
</div></template>


